"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loaderTemplate = void 0;
var tslib_1 = require("tslib");
var loader_dot_1 = (0, tslib_1.__importDefault)(require("./loader.dot"));
var loaderTemplate = loader_dot_1.default.default ? loader_dot_1.default.default : loader_dot_1.default;
exports.loaderTemplate = loaderTemplate;
//# sourceMappingURL=index.js.map